<template>
  <div class="course-tree">
    <div class="treelistall" v-for="(item, key) in data" :key="item.id">
      <!-- 父集 -->
      <div class="tree_list" @click="isetup(item)">
        <div class="tree_left u-line-1 ellipsis">
          <span class="keynum" v-if="key < 9">第0{{ key + 1 }}章</span>
          <span class="keynum" v-else>第{{ key + 1 }}章</span>
          <span class="course_title">{{ item.label }}</span>
        </div>
        <div class="tree_rig">
          <i
            class="el-icon-arrow-down"
            :class="item.childrenshow == true ? 'icon_trfas' : ''"
          ></i>
        </div>
      </div>
      <!-- 子级 -->
      <el-collapse-transition>
        <div class="childer_list transition" v-show="item.childrenshow">
          <div
            class="childer_text"
            v-for="(chilitem, index) in item.children"
            :key="chilitem.chapterId"
            @click="
              chilbtns(
                classStatus,
                chilitem.chapterId,
                index,
                key,
                chilitem.completion,
                chilitem.label
              )
            "
          >
            <div
              class="child_name ellipsis"
              :class="
                idblue == chilitem.chapterId
                  ? 'rigstatus1'
                  : '' || currdata == chilitem.chapterId
                  ? 'rigstatus1'
                  : ''
              "
            >
              <span>{{ chilitem.label }}</span>
            </div>
            <!-- 进度条 -->
            <div class="percentage_all">
              <div class="percentage" v-if="tokens">
                <el-progress
                  :percentage="chilitem.completion"
                  color="#3964E6"
                ></el-progress>
              </div>
              <div v-else>
                <i class="el-icon-lock"></i>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>
<script>
import { getPlayUrlByChapterId, lookstatus } from "@/api/coursedetails.js";
import { getToken } from "../../utils/auth.js";
export default {
  data() {
    return {
      show: true,
      childrenshow: true,
      idblue: null,
      tokens: getToken(),
    };
  },
  onLoad() {},
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    currdata: {},
    classStatus: {
      type: Number,
    },
  },
  created() {
    console.log(this.data);
  },
  methods: {
    isetup(item) {
      item.childrenshow = !item.childrenshow;
    },
    // 资源播放
    async chilbtns(classStatus, chapterId, index, key, completion, label) {
      let tokens = getToken();
      if (tokens == "" || tokens == undefined) {
        if (index == 0 && key == 0) {
          await this.videoIdget(chapterId);
        } else {
          this.$message({
            message: "请先登陆",
            type: "error",
            offset: "130",
          });
        }
      } else {
        if (classStatus == 2) {
          this.$message({
            message: "班级已结束",
            type: "error",
            offset: "150",
          });
          return;
        }

        await this.courselook(chapterId, completion, label);
      }
    },
    //根据章节ID获取视频资源URL
    async videoIdget(chapterId, completion, label, completed, recordLocation) {
      await getPlayUrlByChapterId({ chapterId: chapterId }).then((res) => {
        if (res.code == 200) {
          let urlsa = {
            urlvid: res.data,
            completion: completion,
            label: label,
            completed: completed,
            chapterId: chapterId,
            recordLocation: recordLocation,
          };
          this.$emit("videoURL", urlsa);
        } else {
          this.$message({
            message: "暂无教学资源",
            type: "error",
            offset: "150",
          });
        }
      });
    },

    // 是否可以观看此章节
    async courselook(chapterId, completion, label) {
      var { data } = await lookstatus({ chapterId: chapterId });
      console.log(123);
      if (data.canLook == true) {
        if (this.idblue == chapterId) {
          return false;
        } else {
          this.idblue = chapterId;
          await this.videoIdget(
            chapterId,
            completion,
            label,
            data.completed,
            data.recordLocation
          );
          //调用父组件的查询试题方法
          this.$emit("tkuangtimes", chapterId);
        }
      } else {
        this.$message({
          message: "不能跳章观看",
          type: "error",
          offset: "150",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.course-tree {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  .treelistall {
    width: 100%;
    // 父级
    .tree_list {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #e5e5e5;
      display: flex;

      .tree_left {
        width: 95%;
        padding-left: 20px;
        line-height: 50px;

        .keynum {
          font-size: 14px;
          font-weight: bold;
          color: #1d4434;
        }
        .course_title {
          font-size: 16px;
          font-weight: bold;

          padding-left: 20px;
          &:hover {
            color: #1d4434;
          }
        }
      }
      .tree_rig {
        font-size: 20px;
        color: #999999;
        cursor: pointer;
        line-height: 50px;
        margin-left: 2px;
        // icon图
        .icon_trfas {
          transform: rotate(180deg);
        }
      }
    }
    // 子集
    .childer_list {
      width: 100%;
      .childer_text {
        width: 100%;
        height: 50px;
        padding: 0 15px;
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        line-height: 50px;
        overflow: hidden;
        display: flex;
        border-bottom: 1px solid #e5e5e5;
        // &:hover {
        //   box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
        // }
        // 子集标题
        .child_name {
          width: 70%;
          padding-left: 32px;
          &:hover {
            color: #1d4434;
          }
        }
        .rigstatus1 {
          color: #1d4434 !important;
        }
        .rigstatus2 {
          color: #bbbbbb;
        }
        .percentage_all {
          width: 30%;
          height: 40px;
          float: right;
          text-align: right;
          overflow: hidden;
          position: relative;
          font-size: 14px;

          .percentage {
            width: 100%;
            border-radius: 20px;
            float: right;
            margin-top: 17px;
          }
        }
      }
    }
  }
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
